package pt.at.oss.kotlin.manual.storage.common.supplycommencement

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * SupplyCommencement Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class SupplyCommencement(
    var alreadyCarriedOutSupplies: Boolean? = false,
    var commencementDate: String? = null
) : BaseRecord()
